
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 10.5c0 5.253-4.247 9.5-9.5 9.5A9.492 9.492 0 011 10.5C1 5.247 5.247 1 10.5 1S20 5.247 20 10.5z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.74 14V6.76h2.01c1.187 0 2.12.22 2.8.66.48.307.85.717 1.11 1.23.26.513.39 1.083.39 1.71a3.74 3.74 0 01-.35 1.62c-.227.493-.55.897-.97 1.21-.713.54-1.76.81-3.14.81H7.74zm1.27-1.13h.69c.96 0 1.677-.173 2.15-.52.62-.453.93-1.113.93-1.98 0-.44-.09-.833-.27-1.18a2.289 2.289 0 00-.73-.84c-.447-.307-1.143-.46-2.09-.46h-.68v4.98z","fill":"currentColor"}})])
          )
        }
      }
    